import clsx from 'clsx';
import Link from 'next/link';
import { COMPANY_DETAILS_QUERYResult } from 'sanity.types';

export default function GoogleMap({
    className,
    companyDetails,
}: {
    className?: string;
    companyDetails?: COMPANY_DETAILS_QUERYResult;
}) {
    if (!companyDetails) return <></>;

    const {
        address1,
        town,
        postcode,
        companyName,
        telNumber,
        emailAddress,
        county,
    } = companyDetails[0].companyDetails || {};

    const { mondayToFriday, saturday, sunday } =
        companyDetails[0].openingTimes || {};

    const outerClasses = clsx(
        'w-full',
        className && className,
        'p-4',
        'rounded-md',
        'relative',
        'md:flex-row',
        'flex',
        'md:gap-4',
        'flex-wrap',
        'md:flex-nowrap'
    );

    const topContainerClasses = clsx(
        'w-full',
        'sm:w-1/2',
        'md:w-full',
        'flex',
        'flex-wrap',
        'bg-gray-100',
        'p-2',
        'rounded-lg'
    );

    const headerFontCLasses = clsx('font-bold', 'text-xl', 'mb-2');

    // Important! Always set the container height explicitly
    return (
        <div className={outerClasses}>
            <div className="w-full md:w-1/3 xl:w-1/4 bg-transparent text-xs z-20 drop-shadow-md rounded-lg order-1 md:order-2 md:h-full item-center mb-4 md:mb-0">
                <>
                    <div className="flex flex-wrap mb-4 gap-4 sm:flex-nowrap md:flex-wrap">
                        <div className={topContainerClasses}>
                            <div className={headerFontCLasses}>Who we are:</div>
                            <ul className="p-2 list-none text-sm bg-white w-full rounded-lg">
                                <li>
                                    <strong>{companyName}</strong>, {address1},{' '}
                                    {town}, {county}, {postcode}
                                </li>
                            </ul>
                        </div>
                        <div className={topContainerClasses}>
                            <div className={headerFontCLasses}>
                                Opening times:
                            </div>
                            <ul className="p-2 list-none text-sm bg-white w-full rounded-lg">
                                <li>Monday to Friday: {mondayToFriday}</li>
                                <li>Saturday: {saturday}</li>
                                <li>Sunday: {sunday}</li>
                            </ul>
                        </div>
                    </div>
                    <div className="flex flex-wrap bg-gray-100 p-2 rounded-lg">
                        <div className={`${headerFontCLasses} w-full`}>
                            Contact us:
                        </div>
                        <ul className="p-2 list-none text-sm bg-white w-full rounded-lg">
                            <li>
                                Telephone:{' '}
                                <strong>
                                    <Link href={`tel:${telNumber}`}>
                                        {telNumber}
                                    </Link>
                                </strong>
                            </li>
                            <li>
                                Email:{' '}
                                <strong>
                                    <Link href={`mailto:${emailAddress}`}>
                                        {emailAddress}
                                    </Link>
                                </strong>
                            </li>
                        </ul>
                    </div>
                </>
            </div>

            <div className="w-full order-2 md:order-1 md:w-2/3 xl:w-3/4">
                <iframe
                    src="https://maps.google.com/maps?q=51.4010843,-0.5628053&z=15&output=embed"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-lg"
                ></iframe>
            </div>
        </div>
    );
}
